import ApiBase from '../ApiBase';

class Users extends ApiBase {
    route = '/networking/users';
}

export default new Users;
